import * as React from 'react';
import { Source } from 'react-map-gl';

import { IUIMapSource } from '@components/common/UIMap/utils/types';
import { DEFAULT_SOURCE } from '@components/common/UIMap/utils/constants';

const UIMapSource = (props: IUIMapSource) => {
  const {
    id,
    data = DEFAULT_SOURCE,
    children,
    cluster = true,
    clusterMaxZoom = 24,
    clusterRadius = 50,
    ...rest
  } = props;

  return (
    <Source
      id={id}
      type="geojson"
      data={data}
      cluster={cluster}
      clusterMaxZoom={clusterMaxZoom}
      clusterRadius={clusterRadius}
      {...rest}
    >
      {children}
    </Source>
  );
};

export default UIMapSource;
